<template>
  <div id="app">
    <div>
      <img :src="logoPath"  style="width: 150px; height: auto; margin: 50px auto 100px;"  alt="logo"/>
    </div>
    <van-form @submit="onSubmit">
      <van-field
        v-model="postForm.mobile"
        required
        label="手机号"
        placeholder="请输入手机号"
        :rules="[{ required: true, message: '请填写手机号' }]"
      />
      <!--<van-field
        v-model="postForm.password"
        required
        label="密码"
        type="password"
        placeholder="请输入密码"
        :rules="[{ required: true, message: '请填写密码' }]"
      />-->
      <van-field
        v-if="loginWay === 'code'"
        v-model="postForm.code"
        center
        clearable
        label="验证码"
        placeholder="请输入"
      >
        <template #button>
          <van-button size="small" type="primary" native-type="button" @click="sendCode">{{ sendBtnText }}</van-button>
        </template>
      </van-field>

      <van-field
        v-if="loginWay === 'password'"
        v-model="postForm.pass"
        center
        clearable
        :type="passwordFieldType"
        label="密码"
        placeholder="请输入密码"
      >
        <template #button>
          <van-icon
            :name="passwordFieldType === 'password' ? 'closed-eye' : 'eye'"
            @click="togglePasswordVisibility"
            color="#3a8ee6"
            size="20px"
          />
        </template>
      </van-field>

      <div
        style="display: flex; justify-content: end; margin-right: 16px; margin-top: 12px; font-weight: bold; color: #3a8ee6"
        @click="changeLoginWay"
      >
        {{ loginWayText }}
      </div>

      <div style="margin: 20px;">
        <van-button class="login-button" v-bind:class="{'login-btn-active': loginBtnActive }" type="info" native-type="submit">登入</van-button>
      </div>
    </van-form>
  </div>
</template>

<script>

import {Toast} from 'vant'
import {login, sendSmsCode, getUserInfoByWechatCode, loginPass} from '@/api/user'

export default {
  name: 'login',
  data () {
    return {
      postForm: {
        mobile: '',
        /*password: '',*/
        code: '',
        open_id: '',
        pass: '',
      },
      loginBtnActive: false,
      // 是否已经发送了验证码
      isSmsSend: false,
      // 文本
      sendBtnText: '点击发送验证码',
      // 计时器对象
      timer: null,
      // 倒数60秒
      counter: 59,
      logoPath: require('../../assets/ssr-logo.png'),
      code: '',
      loginWay: 'code',
      showPassword: false,
    }
  },
  watch: {
    postForm: {
      // eslint-disable-next-line camelcase
      handler (new_value, old_value) {
        this.loginBtnActive = (new_value.code !== '' && new_value.mobile !== '') ||  (new_value.pass !== '' && new_value.mobile !== '')
      },
      deep: true
    }
  },
  created() {
    const requests = this.getUrlKey(window.location.href)
    if (localStorage.getItem('token')) {
      this.$router.push('/index')
    }
    this.code = requests && requests.code
    /*if (this.isWechat()) {
      this.getCode()
    }*/
  },
  computed: {
    loginWayText() {
      return this.loginWay === 'code' ? '密码登录' : '验证码登录';
    },
    passwordFieldType() {
      return this.showPassword ? 'text' : 'password';
    },
  },
  methods: {
    togglePasswordVisibility() {
      this.showPassword = !this.showPassword;
    },
    // 登录方式切换
    changeLoginWay() {
      if (this.loginWay === 'code') {
        this.loginWay = 'password'
      } else {
        this.loginWay = 'code'
      }
      console.log('xxx')
    },
    // url参数解析
    getUrlKey(url) {
      const params = {};
      if (url.indexOf("?") <= -1) {
        return false
      }
      const urls = url.split("?");
      const arr = urls[1].split("&");
      let i = 0, l = arr.length;
      for (; i < l; i++) {
        const a = arr[i].split("=");
        params[a[0]] = a[1];
      }
      return params;
    },
    getCode () { // 非静默授权，第一次有弹框
      const local = 'http://erp-worker.zhian-design.com/' // 获取页面url
      const appid = 'wxd7268be3689dbc78'
      console.log(this.code)
      if (this.code == null || this.code === false || this.code === '' || typeof this.code === 'undefined') { // 如果没有code，则去请求
        window.location.href = `https://open.weixin.qq.com/connect/oauth2/authorize?appid=${appid}&redirect_uri=${encodeURIComponent(local)}&response_type=code&scope=snsapi_userinfo&state=123#wechat_redirect`
      } else {
        getUserInfoByWechatCode({code: this.code}).then((res) => {
          if (res.code === 0 && res.data) {
            if (res.data.man && res.data.man.token) {
              localStorage.setItem('token', (res.data.man.type ? res.data.man.type : 'Bearer') + ' ' + res.data.man.token)
              localStorage.setItem('id', res.data.man.id)
              this.forwardPage()
            } else {
              localStorage.setItem('openid', res.data.id)
              this.postForm.openid = res.data.id
              localStorage.setItem('name', res.data.name)
            }
          }
        })
      }
    },
    getUrlCode() { // 截取url中的code方法
      const url = location.search
      this.winUrl = url
      const theRequest = new Object()
      if (url.indexOf("?") != -1) {
        const str = url.substr(1)
        const strs = str.split("&")
        for(let i = 0; i < strs.length; i++) {
          theRequest[strs[i].split("=")[0]]=(strs[i].split("=")[1])
        }
      }
      return theRequest
    },
    isWechat () {
      let ua = window.navigator.userAgent.toLowerCase()
      return ua.indexOf('micromessenger') !== -1
    },
    sendCode () {
      if (this.postForm.mobile === '' || typeof this.postForm.mobile === 'undefined') {
        Toast('手机号不可为空')
        return false
      }
      if (this.postForm.mobile.length !== 11) {
        Toast('手机号不正确')
        return false
      }
      /*if (this.postForm.password === '' || typeof this.postForm.password === 'undefined') {
        Toast('密码不可为空')
        return false
      }*/
      if (!this.isSmsSend) {
        sendSmsCode(this.postForm).then((res) => {
          Toast('短信发送成功')
          this.isSmsSend = true
          this.countDown()
        })
      }
    },
    countDown () {
      // 将setInterval()方法赋值给前面定义的timer计时器对象，等用clearInterval()方法时方便清空这个计时器对象
      this.timer = setInterval(() => {
        // 替换文本，用es6里面的``这个来创建字符串模板，让秒实时改变
        this.sendBtnText = `(${this.counter}秒)后重新发送`
        this.counter--
        if (this.counter < 0) {
          // 当计时小于零时，取消该计时器
          clearInterval(this.timer)
          this.reset()
        }
      }, 1000)
    },
    reset () {
      // 重置按钮可用
      this.isSmsSend = false
      // 重置文本内容
      this.sendBtnText = '点击发送验证码'
      if (this.timer) {
        // 存在计时器对象，则清除
        clearInterval(this.timer)
        // 重置秒数，防止下次混乱
        this.counter = 60
        // 计时器对象重置为空
        this.timer = null
      }
    },
    onSubmit () {
      if (this.loginWay === 'password') {

        if (this.postForm.pass === '' || typeof this.postForm.pass === 'undefined') {
          Toast('缺少密码')
          return false
        }

        loginPass(this.postForm).then((res) => {
          if (res.data.data.id) {
            localStorage.setItem('id', res.data.data.id)
          }
          if (res.data.data.access_token) {
            this.$store.dispatch('notice/setMessageCnt')
            this.$store.dispatch('role/setInfo')
            localStorage.setItem('token', (res.data.data.token_type ? res.data.data.token_type : 'Bearer') + ' ' + res.data.data.access_token)
            localStorage.setItem('name', res.data.data && res.data.data.name)
            localStorage.setItem('id', res.data.data.id)
            this.forwardPage()
          }
        })

        return
      }


      if (this.postForm.code === '' || typeof this.postForm.code === 'undefined') {
        Toast('缺少短信验证码')
        return false
      }
      login(this.postForm).then((res) => {
        if (res.data.data.id) {
          localStorage.setItem('id', res.data.data.id)
        }
        if (res.data.data.access_token) {
          this.$store.dispatch('notice/setMessageCnt')
          this.$store.dispatch('role/setInfo')
          localStorage.setItem('token', (res.data.data.token_type ? res.data.data.token_type : 'Bearer') + ' ' + res.data.data.access_token)
          localStorage.setItem('name', res.data.data && res.data.data.name)
          localStorage.setItem('id', res.data.data.id)
          this.forwardPage()
        }
      })
    },
    forwardPage() {
      if (localStorage.getItem('history_url')) {
        location.href = '#' + localStorage.getItem('history_url')
      } else {
        this.$router.push('/index')
      }
    }
  }
}
</script>

<style>
#app {
  font-family: 'Avenir', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  text-align: center;
  color: #2c3e50;
}
.login-button {
  width: 90%;
  margin: 0 auto;
  background-color: #c9cdd4;
  border: none;
  border-radius: 8px;
}
.login-btn-active {
  background: rgb(230, 108, 94);
}
</style>



// WEBPACK FOOTER //
// src/views/user/login.vue